import { Card, Divider, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import FeaturesSection from "../IAPModal/FeaturesSection";
import ProductIcon from "../ProductIcon";
import type { PurchaseSuccessProduct } from "./types";

const PRODUCT_ICON_SIZE = 56;

type Props = PurchaseSuccessProduct & {
	appFont?: string;
};

export const PurchasedProductCard = ({
	title,
	icon,
	description,
	features,
	appFont,
}: Props) => {
	const theme = useAppTheme();

	return (
		<FlatCard>
			<Card.Content style={{ padding: 16 }}>
				<Box flexDirection="row" alignItems="center" gap={16}>
					<ProductIcon
						image={icon}
						size={PRODUCT_ICON_SIZE}
						showBorder={false}
					/>
					<Box flex={1} minWidth={0} gap={2}>
						<Text
							variant="titleSmall"
							numberOfLines={2}
							style={
								appFont ? { fontFamily: `${appFont}-semibold` } : undefined
							}
						>
							{title}
						</Text>
						{description ? (
							<Text
								variant="bodySmall"
								style={{ color: theme.colors.onSurfaceVariant }}
							>
								{description}
							</Text>
						) : null}
					</Box>
				</Box>
			</Card.Content>
			{features?.length ? (
				<Divider style={{ backgroundColor: theme.colors.surfaceVariant }} />
			) : null}
			{features?.length ? (
				<Card.Content style={{ padding: 16 }}>
					<FeaturesSection features={features} appFont={appFont} />
				</Card.Content>
			) : null}
		</FlatCard>
	);
};
